// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__22dzi","footer":"ChangeClinic_footer__3Uv9k"};